import React, { useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL 
  ? `${process.env.REACT_APP_BACKEND_URL}/api` 
  : '/api';

const ForgotPasswordModal = ({ isOpen, onClose }) => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    setMessage('');

    try {
      await axios.post(`${API}/auth/reset-password`, { email });
      setMessage('Un email de réinitialisation a été envoyé à votre adresse. Veuillez vérifier votre boîte de réception.');
      setEmail('');
      
      // Close modal after 5 seconds
      setTimeout(() => {
        onClose();
        setMessage('');
      }, 5000);
    } catch (err) {
      setError('Erreur lors de l\'envoi de l\'email');
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50" style={{backgroundColor: 'rgba(0, 0, 0, 0.8)'}}>
      <div className="rounded-lg p-6 w-full max-w-md shadow-2xl" style={{backgroundColor: '#2C3148'}}>
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold" style={{color: '#FFFFFF'}}>Mot de passe oublié</h2>
          <button 
            onClick={onClose} 
            className="transition-colors duration-200"
            style={{color: '#8A92B2'}}
            onMouseEnter={(e) => e.currentTarget.style.color = '#FF5757'}
            onMouseLeave={(e) => e.currentTarget.style.color = '#8A92B2'}
          >
            ✕
          </button>
        </div>

        <p className="text-sm mb-4" style={{color: '#8A92B2'}}>
          Entrez votre adresse email. Nous vous enverrons un lien pour réinitialiser votre mot de passe.
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-1" style={{color: '#FFFFFF'}}>
              Adresse email
            </label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2"
              style={{
                backgroundColor: '#242A3D',
                borderColor: '#4A5BFF',
                color: '#FFFFFF'
              }}
              placeholder="votre.email@exemple.com"
              data-testid="forgot-password-email-input"
            />
          </div>

          {error && (
            <div className="text-sm p-3 rounded-md" style={{
              color: '#FF5757',
              backgroundColor: 'rgba(255, 87, 87, 0.1)',
              border: '1px solid #FF5757'
            }} data-testid="forgot-password-error">
              {error}
            </div>
          )}

          {message && (
            <div className="text-sm p-3 rounded-md" style={{
              color: '#00C2FF',
              backgroundColor: 'rgba(0, 194, 255, 0.1)',
              border: '1px solid #00C2FF'
            }} data-testid="forgot-password-success">
              ✅ {message}
            </div>
          )}

          <div className="flex justify-end space-x-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 border rounded-md transition-colors duration-200"
              style={{
                color: '#8A92B2',
                borderColor: '#1C2133'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#1C2133';
                e.currentTarget.style.color = '#FFFFFF';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.color = '#8A92B2';
              }}
              data-testid="forgot-password-cancel-btn"
            >
              Annuler
            </button>
            <button
              type="submit"
              disabled={isLoading || message}
              className="px-4 py-2 rounded-md transition-all duration-300 disabled:opacity-50"
              style={{
                background: 'linear-gradient(135deg, #4A5BFF 0%, #7A5FFF 100%)',
                color: '#FFFFFF'
              }}
              onMouseEnter={(e) => {
                if (!isLoading && !message) {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 8px 20px rgba(74, 91, 255, 0.4)';
                }
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '';
              }}
              data-testid="forgot-password-submit-btn"
            >
              {isLoading ? 'Envoi...' : 'Envoyer le lien'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPasswordModal;
